"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthCookies = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("../constants");
var _validateLoggedInUserCookie = require("./validateLoggedInUserCookie");
var AuthCookies = exports.AuthCookies = {
    /**
   * Gets authorized user cookie value. Usually they take this signature: <tenant>\<consultantNumber>
   */ getAuthorizedUserValue: function() {
        var loggedInUserCookie = _jsCookie.default.get(_constants.LOGGED_IN_USER_COOKIE);
        return (0, _validateLoggedInUserCookie.validateLoggedInUserCookie)(loggedInUserCookie);
    },
    hasAuthorizedUserValue: function() {
        return !!this.getAuthorizedUserValue();
    }
}; //# sourceMappingURL=AuthCookies.js.map
